/**
 * HTTP layer for radio locations. Where each cellular radio is installed: CRUD,
 * the inventory dashboard rollup, per-site-group counts, and an Excel export.
 *
 * Contains:
 * - fetchRadioLocations / fetchRadioLocation: reads
 * - postRadioLocation / patchRadioLocation / deleteRadioLocation: writes
 * - bulkSetRadioLocationsDeleted: batch soft-delete/restore RPC
 * - fetchInventoryDashboard / fetchRadioSiteGroupCounts: inventory rollups
 * - fetchRadioLocationExcelReport: Excel export
 */
import apiClient from '@sophocles/http-common';

const RADIO_LOCATION_ENDPOINT = '/inventory/radio-locations';

export const fetchRadioLocations = queryParams =>
  apiClient.get(`${RADIO_LOCATION_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchRadioLocation = radioLocationId =>
  apiClient.get(`${RADIO_LOCATION_ENDPOINT}/${radioLocationId}/`).then(res => res.data);

export const postRadioLocation = data => apiClient.post(`${RADIO_LOCATION_ENDPOINT}/`, data).then(res => res.data);

export const patchRadioLocation = (radioLocationId, data) =>
  apiClient.patch(`${RADIO_LOCATION_ENDPOINT}/${radioLocationId}/`, data).then(res => res.data);

export const deleteRadioLocation = radioLocationId =>
  apiClient.delete(`${RADIO_LOCATION_ENDPOINT}/${radioLocationId}/`);

// Batch soft-delete/restore — bare RPC returning { updated, not_found }, no
// {data} envelope (unlike the CRUD writes above).
export const bulkSetRadioLocationsDeleted = body =>
  apiClient.post(`${RADIO_LOCATION_ENDPOINT}/bulk-set-deleted/`, body).then(res => res.data);

export const fetchRadioLocationExcelReport = queryParams =>
  apiClient
    .get(`${RADIO_LOCATION_ENDPOINT}/xlsx/`, { responseType: 'blob', params: queryParams })
    .then(res => res.data);

export const fetchInventoryDashboard = queryParams =>
  apiClient.get(`${RADIO_LOCATION_ENDPOINT}/dashboard/`, { params: queryParams }).then(res => res.data);

export const fetchRadioSiteGroupCounts = queryParams =>
  apiClient.get(`${RADIO_LOCATION_ENDPOINT}/sitegroupcounts/`, { params: queryParams }).then(res => res.data);
